module.exports = __webpack_public_path__ + "media/images/dotted-faabc4c4c853dc7113f6de19a732dbdf.svg";